const damColors = {
  'color-initial': '#fff',
  'color-initial-dark': '#000',
  'color-initial-special': '#565F62',

  'color-primary-light': '#F3BA48', // Surcharge
  'color-primary': '#eb9b00', // Surcharge
  'color-primary-dark': '#B97921', // Surcharge

  'color-secondary-light': '#f0f0f0', // Surcharge
  'color-secondary-light2': '#BEBEBE',
  'color-secondary-light3': '#dfdfdf',
  'color-secondary': '#565F62', // Surcharge
  'color-secondary-dark': '#000', // Surcharge
  'color-secondary-dark2': '#565F62', // Surcharge

  'color-tertiary-light': '#185673',
  'color-tertiary': '#163348',
  'color-tertiary-dark': '#0e2434',

  'color-quaternary-light': '#9facb5',
  'color-quaternary-light2': '#c3cfd7',
  'color-quaternary': '#4e7891',
  'color-quaternary-dark': '#375364',

  'color-quinary-light': '#f1f1f1',
  'color-quinary-light2': '#e6e6e6', // Surcharge
  'color-quinary': '#BEBEBE', // Surcharge
  'color-quinary-dark': '#707070', // Surcharge
  'color-quinary-special': '#cdcdcd',

  'color-senary': '#c4cbd1',

  'color-error': '#CC0000',
  'color-error-background': '#CC0000',

  'color-warning': '#F57F17',
  'color-warning-background': '#DE65F57F1700',

  'color-success': '#3D9D20',

  'color-info': '#046489',
  'color-info-background': '#046489',

  'color-valid': '#6EBE64',
  'color-valid-background': '#6EBE64',
};

const buttonColors = {
  'color-btn-primary': damColors['color-primary'],
  'color-btn-primary-light': damColors['color-primary-light'],
  'color-btn-primary-dark': damColors['color-primary-dark'],
  'color-btn-secondary': damColors['color-secondary'],
  'color-btn-secondary-light': damColors['color-secondary-light2'],
  'color-btn-secondary-light2': damColors['color-secondary-light2'],
  'color-btn-secondary-dark': damColors['color-secondary-dark'],
  'color-btn-secondary-dark2': damColors['color-secondary-dark2'],
  'color-btn-tertiary': damColors['color-quaternary'],
  'color-btn-tertiary-light': damColors['color-quaternary-light'],
  'color-btn-tertiary-dark': damColors['color-quaternary-dark'],
};

const damTheme = {
  ...damColors,
  ...buttonColors,
};

export default damTheme;
